module.exports = __webpack_public_path__ + "static/media/giaCore-logo.084e4523.png";